<div class="wrapper-custom-rating">
    <span class="text-rating">{{averageRating}}</span>
    <div class="wrapper-stars-rating">
        <img *ngFor="let star of stars" [src]="star" alt="star">
    </div>
    <span class="text-rating">({{reviewsCount}})</span>
</div>